import { memo } from "react";
import moment from "moment";

//scss
import "./style.scss";

//assets
import { SvgCalendar as Calendar } from "assets/icons/js/SvgCalendar";
import { SvgGuest as Guest } from "assets/icons/js/SvgGuest";

const BookingDetails = memo(({ dates, guestsData, onClick }: any) => {
	return (
		<div className="booking-details" onClick={onClick}>
			<div className="booking-details__dates text-12px-light">
				<Calendar />
				<span>
					{`${moment(dates.checkin).format("Do MMM")} - ${moment(
						dates.checkout,
					).format("Do MMM")}`}
				</span>
			</div>
			{/* <span>•</span> */}
			<div className="booking-details__guests text-12px-light">
				<Guest />
				{guestsData.guests !== 0 && <span>{guestsData.guests} Guest(s)</span>}
				{guestsData.rooms !== 0 && (
					<span>{", " + guestsData.rooms} Room(s)</span>
				)}
				{guestsData.pets && <span>{", " + guestsData.pets} Pet(s)</span>}
			</div>
		</div>
	);
});

export default BookingDetails;
